import React from 'react';
import {Box, Skeleton, Typography} from '@mui/material';
import {alpha} from '@mui/material/styles';
import DashboardPaper from './DashboardPaper';
import {dashboardMetrics, formatMetric} from './dashboardMetrics';

const metrics = [...dashboardMetrics, {key: 'roi', label: 'ROI'}];

export default function Stats({stats, currencyCode, error}) {
    return (
        <Box sx={{display: 'grid', gap: 1.5, gridTemplateColumns: {xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(4, minmax(0, 1fr))', lg: 'repeat(7, minmax(0, 1fr))'}}}>
            {metrics.map(metric => (
                <DashboardPaper key={metric.key} sx={{p: {xs: 1.5, sm: 2}, minWidth: 0, backgroundColor: 'background.darkBlue',
                    gridColumn: metric.key === 'roi' ? {xs: 'span 2', lg: 'span 1'} : 'auto'}}>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 1.5}}>
                        <Box sx={{width: 7, height: 7, borderRadius: '50%', flexShrink: 0,
                            bgcolor: metric.currency ? 'secondary.main' : 'primary.main'}}/>
                        <Typography sx={{fontSize: 12, fontWeight: 500, color: 'text.secondary'}}>{metric.label}</Typography>
                    </Box>
                    {stats == null && !error ? <Skeleton width="75%" height={32}/> :
                        <Typography title={error ? 'Report unavailable' : formatMetric(stats?.[metric.key], metric, currencyCode)}
                                    sx={{fontSize: {xs: 20, sm: 23}, fontWeight: 700, letterSpacing: '-0.6px', fontVariantNumeric: 'tabular-nums',
                                        overflowWrap: 'anywhere', color: Number(stats?.[metric.key]) < 0 ? 'error.main' : 'text.primary'}}>
                            {error ? '—' : formatMetric(stats?.[metric.key], metric, currencyCode, true)}
                        </Typography>}
                    <Box sx={{mt: 1.5, height: 3, borderRadius: 2, bgcolor: theme => alpha(
                        metric.currency ? theme.palette.secondary.main : theme.palette.primary.main, 0.12)}}/>
                </DashboardPaper>
            ))}
        </Box>
    );
}
